import { Skeleton, Typography, Paper, useTheme } from '@mui/material';

type Props = {
	dateToView: Date;
	loading: boolean;
	sessionCount: number;
};

const weekDayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

export const ColumnHeader = ({ dateToView, loading, sessionCount }: Props) => {
	const theme = useTheme();
	const isToday = new Date().toDateString() === dateToView.toDateString();

	return (
		<Paper
			elevation={0}
			sx={{
				p: 1.5,
				textAlign: 'center',
				borderRadius: 2,
				backgroundColor: isToday ? theme.palette.primary.light : theme.palette.background.paper,
				color: isToday ? theme.palette.common.white : 'inherit',
				borderBottom: `3px solid ${isToday ? theme.palette.primary.main : 'transparent'}`,
			}}
		>
			{loading ? (
				<>
					<Skeleton variant="text" width="100%" height={32} />
					<Skeleton variant="text" width="60%" height={24} style={{ margin: '0 auto' }} />
				</>
			) : (
				<>
					<Typography variant="h6" fontWeight={isToday ? 700 : 500}>
						{weekDayNames[dateToView.getDay()].substring(0, 3)}
					</Typography>
					<Typography variant="subtitle2" color={isToday ? 'inherit' : 'text.secondary'}>
						{dateToView.getDate()}/{dateToView.getMonth() + 1}
					</Typography>
					<Typography
						variant="caption"
						sx={{ display: 'block', mt: 0.25, opacity: isToday ? 0.9 : 0.7 }}
						color={isToday ? 'inherit' : 'text.secondary'}
					>
						{sessionCount} {sessionCount === 1 ? 'session' : 'sessions'}
					</Typography>
				</>
			)}
		</Paper>
	);
};
